import Tags from './tags';
import TagEdit from './tag_edit';
import TagAdd from './tag_add';
import TagView from './tag_view';

export {
  Tags,
  TagEdit,
  TagAdd,
  TagView
};
